export enum SelectEntriesPayloadTypes {
  Shifts = 'shifts',
  Timesheets = 'timesheets',
}

export enum DeleteDialogModes {
  Individual = 'individual',
  Multiple = 'multiple',
}
